// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","MainHeading":"MainHeading-nehdecymdcde6htdyakpg4m7q4usja7pddnj3kj2818ygujj4213mm2499gxfgk4wt9v9sucfjvhyjmen7vcewwpc8x93js6uz8meg","ContentWrapper":"ContentWrapper-nscv3f6e582v35gzsbk15hmtbzqhwx2hsy8v3sfnggcwan91z5mt294j4hqpsdmg16d8x8xrerxt83dpd2ggqu8h4hqe18humvhgbb","loading":"loading-fhdr1hhxfxf3eejeejcfcb6fcaypu9896657a39v3v18b5e1h3fd767ayfp9vb2ddcc5wgs85gatj7w1d9rbesbq7rdyuxyuqyu4j7","pulse":"pulse-3wxdvsy5j1vyysgczh8xu1awqj2813wed4x1pd6kfqdt1qmtzsx5uzfthzjkkp2utd11xrb2cf9fzagqpv56ybgv9z1rjp8cettwzww"};


//////////////////
// WEBPACK FOOTER
// ./src/views/History/HistoryView.module.scss
// module id = 1642
// module chunks = 0